import { TextBox } from '@apply/components';
import { useExperienceAddressStreet2 } from '../../../../fields/ExperienceFields';

interface ExperienceStreetAddress2Props {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
    validator?: React.ReactNode;
}

export const ExperienceStreetAddress2: React.FC<ExperienceStreetAddress2Props> = ({
    experienceId,
    required = false,
    readOnly = false,
    validator,
}) => {
    const label = 'Street Address (cont.) ';
    const [streetAddress2, set_streetAddress2] = useExperienceAddressStreet2(experienceId);

    return (
        <>
            <TextBox
                id='experienceStreetAddress2'
                value={streetAddress2}
                onChange={(value) => set_streetAddress2(value)}
                label={label}
                required={required}
                width='100%'
                readOnly={readOnly}
                maxLength={50}
                validator={validator}
            />
        </>
    );
};
